import "regenerator-runtime/runtime.js";
import { useEffect, useMemo, useRef } from "react";
import debounce from "lodash/debounce";

export const useDebouncedCallback = (
  callback: (...args: any[]) => any,
  debounceTime: number
) => {
  const executableCallback = useRef(callback);

  useEffect(() => {
    executableCallback.current = callback;
  }, [callback]);

  const debounced = useMemo(() => {
    return debounce(
      (...args) => {
        executableCallback.current(...args);
      },
      debounceTime,
      { leading: false }
    );
  }, [debounceTime]);

  useEffect(() => {
    return () => {
      debounced.cancel();
    };
  }, [debounced]);

  return debounced;
};
